/**
 * Product details — tab interactions.
 *   - Desktop: simple "active" class swap on .details-tabs .tab clicks.
 *   - Mobile: a button (.mob_btn_tab .btn-text) toggles a dropdown
 *     (.details-tabs_mob). Picking an item closes the dropdown and
 *     updates the button label to the chosen tab.
 */
(function () {
  function init() {
    const tabs = document.querySelectorAll('.details-tabs .tab');
    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        tabs.forEach((t) => t.classList.remove('active'));
        this.classList.add('active');
      });
    });

    const btnMob = document.querySelector('.mob_btn_tab .btn-text');
    const tabList = document.querySelector('.details-tabs_mob');
    const tabLinks = document.querySelectorAll('.details-tabs_mob li a');

    if (btnMob && tabList) {
      btnMob.addEventListener('click', function (e) {
        e.preventDefault();
        tabList.classList.toggle('open');
      });
    }

    tabLinks.forEach((link) => {
      link.addEventListener('click', function () {
        if (btnMob) btnMob.textContent = this.textContent;
        if (tabList) tabList.classList.remove('open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
